import { FC } from "react";
import { IVDPBlockData, IVDPPageBlock, VDPBlockPosition } from "../../../types/vdp";
import VDPSidebarConditionalContentClient from "./vdp-sidebar-conditional-content-client";
import { FilterValue } from "@/types/filters";
import { isVehicleMatchCondition } from "@/types/site";

type WidgetConfig = {
  content?: string;
  condition: FilterValue[];
};

const VDPSidebarConditionalContent: FC<IVDPPageBlock> = ({ vdpGlobalData, renderingPosition, config }) => {
  if (renderingPosition !== VDPBlockPosition.RIGHT && !vdpGlobalData.isSingleColumnRendering) {
    return null;
  }
  const widgetConfig: WidgetConfig = config;

  if (!widgetConfig.content) {
    return null;
  }

  if (config.condition && !isVehicleMatchCondition(vdpGlobalData.vehicle, config.condition)) {
    return null;
  }
  return <VDPSidebarConditionalContentClient content={widgetConfig.content}></VDPSidebarConditionalContentClient>;
};

const VDPBlockData: IVDPBlockData = {
  component: (props: IVDPPageBlock, key: any) => (
    <VDPSidebarConditionalContent
      key={key}
      config={props.config}
      siteData={props.siteData}
      pageContext={props.pageContext}
      renderingPosition={props.renderingPosition}
      vdpGlobalData={props.vdpGlobalData}
      translations={props.translations}
    />
  ),
  position: VDPBlockPosition.RIGHT,
};

export default VDPBlockData;
